export const cardDetails = {
    CREDIT: {
        MAIN: {
            fields: [
                ['balance', 'limit', 'outstandingAmount', 'installmentDueDate', 'repaymentRate'],
                [
                    'previousCycleEndDate',
                    'currentCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                    'hrMinimalPaymentRate',
                    'currentCycleTurnover',
                ],
                ['owner', 'hrDateOfContracting', 'validDates'],
            ],
        },
        AUTHORIZED: {
            fields: [['previousCycleEndDate']],
        },
        AUTHORIZED_STANDALONE: {
            fields: [['previousCycleEndDate']],
        },
        BUSINESS: {
            fields: [['previousCycleEndDate']],
        },
    },
    VIRTUAL_CREDIT: {
        MAIN: {
            fields: [
                ['balance', 'limit', 'outstandingAmount', 'installmentDueDate', 'repaymentRate'],
                [
                    'previousCycleEndDate',
                    'currentCycleEndDate',
                    'outstandingMonthlyAmount',
                    'minimalMonthlyAmount',
                    'hrMinimalPaymentRate',
                    'currentCycleTurnover',
                ],
                ['owner', 'hrDateOfContracting', 'validDates'],
            ],
        },
        AUTHORIZED: {
            fields: [['previousCycleEndDate']],
        },
        AUTHORIZED_STANDALONE: {
            fields: [['previousCycleEndDate']],
        },
        BUSINESS: {
            fields: [['previousCycleEndDate']],
        },
    },
};
